import './style.css';
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import * as dat from 'dat.gui';
import vertexShader from './shaders/vertex.glsl';
import fragmentShader from './shaders/fragment.glsl';
import vertexShaderFull from './shaders/Full/vertex.glsl';
import fragmentShaderFull from './shaders/Full/fragment.glsl';
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js';
import { CustomPass } from './shaders/CustomPass';
import { RGBShiftShader } from 'three/examples/jsm/shaders/RGBShiftShader.js';
import { DotScreenShader } from 'three/examples/jsm/shaders/DotScreenShader.js';
import Stats from 'stats.js';
import './scripts/globe.js';
import './scripts/blockchain.js';

// Register ScrollTrigger because it's not included in gsap
gsap.registerPlugin(ScrollTrigger);

// Stat panel to check performance
// const stats = new Stats();
// stats.showPanel(0); // 0: fps, 1: ms, 2: mb, 3+: custom
// document.body.appendChild(stats.dom);

/**
 * Base
 */
const urls = [
    {
        link: '/brm.jpg',
        url: "https://bongani.vercel.app"
    },
    {
        link: '/nl.jpg',
        url: "https://test-artist.vercel.app/"
    },
    {
        link: '/qa.jpg',
        url: "https://quadafrica.co.za"
    },
    {
        link: '/dfinity.jpg',
        url: "https://dfinity-nbeats-draft-1.vercel.app"
    }];

// Images are 1920x850
const imgWidth = 1920 / 850;
const imgHeight = 1;

// Debug
const params = {
    scale: 1.75,
    progress: 1

};

const gui = new dat.GUI();
gui.add(params, 'scale').min(0).max(10).step(0.1).onChange((val) => {
    effect1.uniforms['scale'].value = val;
});
gui.add(params, 'progress').min(0).max(1).step(0.01).onChange((val) => {
    effect1.uniforms['progress'].value = val;
});

gui.hide();

// Loading manager for loading pictures and fonts
const manager = new THREE.LoadingManager(
    // Loaded
    () => {
        document.getElementById('loading-overlay').style.display = 'none';
        console.log('loaded');
    },

    // Progress
    () => {
        console.log('progress');
    }
);
let raycasterLinks = new THREE.Raycaster();

// Links for when user clicks picture plane
const mouseDownLinks = (event) => {

    // getBoundingClientRect to get mouse position
    const rect = renderer.domElement.getBoundingClientRect();
    mouseLinks.x = ((event.clientX - rect.left) / (rect.width - rect.left)) * 2 - 1;
    mouseLinks.y = - ((event.clientY - rect.top) / (rect.bottom - rect.top)) * 2 + 1;

    // ray caster to click links
    raycasterLinks.setFromCamera(mouseLinks, cameraBasePerspective);
    const intersectsLinks = raycasterLinks.intersectObjects(meshes);

    if (intersectsLinks.length > 0) {
        window.open(intersectsLinks[0].object.userData.URL);
    }

};

// Canvas
const canvas = document.querySelector('canvas.webgl');

// Scenes
const distortedScene = new THREE.Scene();
const baseScene = new THREE.Scene();
const fullScene = new THREE.Scene();

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
};

/**
 * Meshes
 */
// Geometry
const geometry = new THREE.PlaneBufferGeometry(imgWidth / 2.5, imgHeight / 2.5, 32, 32);
const geometryBrush = new THREE.PlaneBufferGeometry(0.1, 0.1, 32, 32);

// Materials
const material = new THREE.ShaderMaterial({
    uniforms: {
        uTime: { value: 0 },
        uTexture: { value: null }
    },
    vertexShader: vertexShader,
    fragmentShader: fragmentShader,
    side: THREE.DoubleSide
});

const meshes = [];
// See linkedn to see all projects

const textures = urls.map(url => new THREE.TextureLoader(manager).load(url.link));

textures.forEach((texture, i) => {
    const m = material.clone();
    m.uniforms.uTexture.value = texture;
    const mesh = new THREE.Mesh(geometry, m);
    if (window.innerWidth < 1200) {
        mesh.scale.x = mesh.scale.y = 0.75; //What are these values?
        mesh.position.x = 0;
        mesh.position.y = i * 0.25 - 1.7;
    } else {
        mesh.position.x = (i % 2) - 0.5;
        mesh.position.y = -params.progress;
        mesh.rotation.z = (params.progress) * Math.PI / 2;

    }
    mesh.userData = { URL: urls[i].url };
    meshes.push(mesh);
    baseScene.add(mesh);
});

/**
 * Plane for full render
 */
const geometryFull = new THREE.PlaneBufferGeometry(imgWidth, imgHeight, 64, 63);
const materialFull = new THREE.ShaderMaterial({
    uniforms: {
        uTime: { value: 0 },
        uTexture: { value: null },

        uDisplacement: { value: null },
    },
    vertexShader: vertexShaderFull,
    fragmentShader: fragmentShaderFull,
    side: THREE.DoubleSide
});
const meshFull = new THREE.Mesh(geometryFull, materialFull);
fullScene.add(meshFull);

/**
 * Cameras
 */
// Orthographic camera
let frustumSize = imgHeight;
let aspect = imgWidth / imgHeight;

let cameraOrth = new THREE.OrthographicCamera(frustumSize * aspect / -2, frustumSize * aspect / 2, frustumSize / 2, frustumSize / -2, -1000, 1000);

cameraOrth.position.set(0.0, - 0.0, 1);
distortedScene.add(cameraOrth);

// Base camera;
const cameraBasePerspective = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100);
cameraBasePerspective.position.set(0, 0, 1.25);
baseScene.add(cameraBasePerspective);

// Controls
// const controls = new OrbitControls(cameraBasePerspective, canvas);
// controls.enableDamping = true;

/**
 * Mouse & Raycaster
 */

let mouse = new THREE.Vector2(0, 0);
let mouseLinks = new THREE.Vector2(0, 0);
let prevMouse = new THREE.Vector2(0, 0);

let currentWave = 0;
let raycaster = new THREE.Raycaster();

const pointerMove = (e) => {

    const rect = renderer.domElement.getBoundingClientRect();
    mouse.x = ((event.clientX - rect.left) / (rect.width - rect.left)) * 2 - 1;
    mouse.y = - ((event.clientY - rect.top) / (rect.bottom - rect.top)) * 2 + 1;

    raycaster.setFromCamera(mouse, cameraOrth);

    const intersects = raycaster.intersectObjects(fullScene.children);

    if (intersects.length > 0) {
        mouse.x = intersects[0].point.x;
        mouse.y = intersects[0].point.y;
    }

};

window.addEventListener('pointermove', pointerMove);

window.addEventListener('mousedown', mouseDownLinks);

window.addEventListener('resize', () => {
    // Update sizes
    sizes.width = window.innerWidth;
    sizes.height = window.innerHeight;

    // Update camera
    cameraOrth.aspect = sizes.width / sizes.height;
    cameraOrth.updateProjectionMatrix();

    // Update renderer
    renderer.setSize(sizes.width, sizes.height);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
});

/**
 * Brush effect
 */
let max = 50;
let brushMeshes = [];

// Add 50 brush meshes 
for (let i = 0; i < max; i++) {
    let brushMat = new THREE.MeshBasicMaterial({
        map: new THREE.TextureLoader(manager).load('/brush.png'),
        transparent: true,
        blending: THREE.AdditiveBlending,

    });
    let mesh = new THREE.Mesh(geometryBrush, brushMat);
    mesh.visible = false;
    mesh.rotation.z = 2 * Math.PI * Math.random();

    brushMeshes.push(mesh);
    distortedScene.add(mesh);
}

// On each mouse move start a new wave
function setNewWave(mouseX, mouseY, index) {
    let mesh = brushMeshes[index];
    mesh.visible = true;
    mesh.position.x = mouseX;
    mesh.position.y = mouseY;
    mesh.material.opacity = 0.5;
    mesh.scale.x = mesh.scale.y = 0.1;
}

function trackMousePos() {
    // check previous vs current mouse position
    if (Math.abs(mouse.x - prevMouse.x) < 0.001 && Math.abs(mouse.y - prevMouse.y) < 0.001) {
        // do nothing because mouse hasn't moved
    } else {
        // make a mesh visible
        setNewWave(mouse.x, mouse.y, currentWave);
        currentWave = (currentWave + 1) % max; //mod creates a loop,
        // so when current wave is factor of 50 it goes back to 0
    }
    prevMouse.x = mouse.x;
    prevMouse.y = mouse.y;
}

/**
 * RenderTargets
 */
let baseTexture = new THREE.WebGLRenderTarget(sizes.width, sizes.height, {
    minFilter: THREE.LinearFilter,
    magFilter: THREE.LinearFilter,
    format: THREE.RGBAFormat
}

);
let testTexture = new THREE.WebGLRenderTarget(sizes.width, sizes.height, {
    minFilter: THREE.LinearFilter,
    magFilter: THREE.LinearFilter,
    format: THREE.RGBAFormat
}
);

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true,
});
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
renderer.setClearColor(0x050D20);

/*
* Postprocessing
*/
let composer = new EffectComposer(renderer, testTexture);
composer.setSize(sizes.width, sizes.height);
composer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
composer.addPass(new RenderPass(baseScene, cameraBasePerspective));

// Effect for...ikd
const effect1 = new ShaderPass(CustomPass);
effect1.uniforms['progress'].value = params.progress;
effect1.uniforms['scale'].value = params.scale;
composer.addPass(effect1);
// noyes
let lastScrollTop = 0;

// Animate function for images
window.addEventListener('scroll', (e) => {
    let st = window.pageYOffset || document.documentElement.scrollTop;
    let num;
    if (st > lastScrollTop && (params.progress === 1)) {
        gsap.to(params, {
            duration: 1,
            progress: 0,

            scrollTrigger: {
                trigger: canvas,
                start: 'bottom bottom',
            },
            onUpdate: () => {

                meshes.forEach((mesh, index) => {
                    let n = 1;
                    if (index >= 2) {
                        n = 0;
                    }
                    if (window.innerWidth > 1200) {
                        mesh.position.y = n * 0.5 - 0.5;
                        mesh.position.x = (index % 2) - 0.5;
                        mesh.rotation.z = (params.progress) * Math.PI / 2;
                    } else {
                        mesh.position.y = index * 0.35 - 0.5;
                        mesh.rotation.z = (params.progress) * Math.PI / 2;
                    }
                });
                effect1.uniforms['progress'].value = params.progress;
                document.querySelector('.main-title').style.opacity = Math.pow(params.progress, 2);
                document.querySelector('.main-subtitle').style.opacity = Math.pow(params.progress, 2);
                document.querySelector('.projects-title').style.opacity = Math.pow(1 - params.progress, 2);
                document.querySelector('.projects-subtitle').style.opacity = Math.pow(1 - params.progress, 2);

            },
            onComplete: () => {
                params.progress = 0;
                document.querySelector('.projects-title').style.opacity = 1;
                document.querySelector('.projects-subtitle').style.opacity = 1;
                document.querySelector('.main-title').style.opacity = 0;
                document.querySelector('.main-subtitle').style.opacity = 0;
            }
        });
    } else if ((st < lastScrollTop) && (params.progress === 0)) {

        gsap.to(params, {
            duration: 1,
            progress: 1,
            scrollTrigger: {
                trigger: canvas,
                start: 'top top',
                // markers: true,

            },
            onUpdate: () => {
                meshes.forEach((mesh, index) => {

                    if (window.innerWidth > 1200) {
                        mesh.position.y = -params.progress;
                        mesh.rotation.z = (params.progress) * Math.PI / 2;
                    } else {
                        mesh.position.y = index * 0.25 - 1.7;
                        // mesh.rotation.z = (params.progress) * Math.PI / 2;
                    }
                });
                effect1.uniforms['progress'].value = params.progress;
                document.querySelector('.main-title').style.opacity = Math.exp(params.progress * 2) - 1;
                document.querySelector('.main-subtitle').style.opacity = Math.exp(params.progress * 2) - 1;
                document.querySelector('.projects-title').style.opacity = Math.pow(1 - params.progress, 2);
                document.querySelector('.projects-subtitle').style.opacity = Math.pow(1 - params.progress, 20);

            },
            onComplete: () => {
                params.progress = 1;
                document.querySelector('.main-title').style.opacity = 1;
                document.querySelector('.main-subtitle').style.opacity = 1;
                document.querySelector('.projects-title').style.opacity = 0;
                document.querySelector('.projects-subtitle').style.opacity = 0;
            }
        });
    }
    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

});
/**
 * Animate
 */
const clock = new THREE.Clock();

const tick = () => {
    // stats.begin();
    // Update controls
    // controls.update();
    trackMousePos();
    // Get elapsedtime
    const elapsedTime = clock.getElapsedTime();

    effect1.uniforms['time'].value = elapsedTime * 0.3;
    // Update meshes;

    brushMeshes.forEach(m => {
        if (m.visible) {
            m.rotation.z += 0.02;
            m.material.opacity *= 0.96;
            m.scale.x = 0.982 * m.scale.x + 0.107;
            m.scale.y = m.scale.x;
            if (m.material.opacity < 0.002) {
                m.visible = false;
            }

        }
    });

    // What other section can i add? 
    // How to make one canvas for all the sections?
    // Should i make this with next.js?
    // Get inspiration from awwwards.com
    // Need to divide and conquer this work
    // 
    // 

    // Render
    renderer.setRenderTarget(baseTexture);
    renderer.render(distortedScene, cameraOrth);
    materialFull.uniforms.uDisplacement.value = baseTexture.texture;
    renderer.setRenderTarget(null);
    renderer.clear();

    composer.renderToScreen = false;
    composer.render();
    materialFull.uniforms.uTexture.value = composer.readBuffer.texture;

    renderer.render(fullScene, cameraOrth);
    // stats.end();
    // Call tick again on the next frame
    window.requestAnimationFrame(tick);
};

tick();